<template>
    <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.6662 10.0632C15.3541 14.766 11.4406 18.4838 6.65887 18.4838H1.03711" stroke="#04042B" stroke-width="1.8" stroke-miterlimit="10"/>
        <path d="M9.92387 10.8527H12.3673C16.3891 10.8527 19.6494 7.59238 19.6494 3.5706V1C9.34962 1 1 9.34962 1 19.6494V22.9251" stroke="#04042B" stroke-width="1.8" stroke-miterlimit="10"/>
    </svg>
</template>
